<template>
  <div class="global-search">
    <input
      v-if="!isShowingResults || searched!==query"
      :value='`Lookup "${query}"?`'
      type="button"
      @click="search()"
      class="btn btn-plain btn-light global-search__button"
    />
    <h3 class="search-results" v-else>{{ t('search results') }}</h3>
    <SearchListItem
      v-for="(word, idx) in words" :key="word.id"
      @click="genHandler(idx)"
      @keydown="genHandler(idx)"
      :is-selecting="false" :word="word"
    />
  </div>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component';
import { Selectable } from '@/includes/definitions/index.d';

import LanguageMixin from '@/includes/mixin/language.mixin';
import DictionaryDatabase from '@/includes/db/DictionaryDatabase';
import { databases } from '@/includes/db/data/languages';
import store from '@/includes/store';
import { DictionaryMeaning, DictionaryWord, WordText } from '@/includes/definitions/word.d';
import SearchListItem from '@/components/word/SearchListItem.vue';
import { WordsModel } from '@/includes/db/schemas/words.schema';

@Options({
  name: 'Global Search',
  components: { SearchListItem },
  emits: ['wordbook-updated'],
  props: {
    query: {
      type: String,
      required: true,
    },
    wordbook: {
      type: Map,
      required: true,
    },
    language: {
      type: String,
      required: false,
      default: null,
    },
  },
})
export default class Support extends mixins(LanguageMixin) {
  query: string;
  words: Selectable<Partial<WordText>>[] = [];
  dictionary: DictionaryDatabase;
  isShowingResults = false;
  wordbook: Map<string, Selectable<WordText>>;
  language: string | null;
  searched = '';

  async search() {
    this.words = [];
    this.searched = this.query;
    const words = await this.dictionary.prefixSearch(this.query.toLowerCase().trim());
    words.forEach((word: DictionaryWord) => {
      const noteWords: Selectable<Partial<WordText>>[] = word
        .meanings.map((meaning: DictionaryMeaning) => ({
          text: meaning.text,
          meaning: meaning.meaning,
          type: meaning.type,
          gender: meaning.gender,
          textLanguage: word.language,
          meaningLanguage: meaning.language,
          selected: this.wordbook.has(meaning.text + meaning.meaning),
        }));
      this.words = [...this.words, ...noteWords];
    });
    this.isShowingResults = true;
  }

  async genHandler(idx: number) {
    this.words[idx].selected = true;
    this.$emit('wordbook-updated', this.words[idx]);
  }

  async mounted() {
    const language = this.language || store.state.translationLanguage;
    this.dictionary = new DictionaryDatabase<DictionaryWord>(databases[language]);
  }
}
</script>

<style scoped lang="scss">
.global-search {
  .search-results {
    margin-top: 15px;
    margin-bottom: 0;
  }

  &__button {
    text-decoration: underline;
    cursor: pointer;
    text-transform: none;
  }
}
</style>
